import { render, staticRenderFns } from "./Statuses.vue?vue&type=template&id=adb72668"
import script from "./Statuses.vue?vue&type=script&lang=js"
export * from "./Statuses.vue?vue&type=script&lang=js"
import style0 from "./Statuses.vue?vue&type=style&index=0&id=adb72668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports